import Box from '@mui/material/Box';
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarContainer,
} from '@mui/x-data-grid';

export default function ToolbarGrid(props) {
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{ fileName: props?.fileName }}
          printOptions={{ disableToolbarButton: true }}
        />
      </GridToolbarContainer>
    );
  }
  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={props?.data}
        columns={props?.columns}
        options={{
          debounceInterval: 700,
          padding: 'dense',
          filtering: true,
          showTitle: false,
          search: false,
          resizable: false,
        }}
        density="compact"
        hideFooter={props.hideFooter ?? false}
        components={{ Toolbar: CustomToolbar }}

        {...(props.serverPagination && {
          pagination: true, 
          paginationMode: "server",
          rowCount: props.rowCount,
          paginationModel: {
            page: props.page,
            pageSize: props.pageSize,
          },
          onPaginationModelChange: (model) => {
            props.onPageChange?.(model.page);
            props.onPageSizeChange?.(model.pageSize);
          },
          pageSizeOptions: [5, 10, 20, 50],
        })}
      />
    </Box>
  );
}
